<div class="page-content">
  <app-content-header [configuration]="headerConfig">
    <app-button icon="add" aria-label="New message">
      {{ 'messages.newMessage' | translate }}
    </app-button>
  </app-content-header>

  <div class="flex h-full w-full flex-row">
    <div class="w-2/5">
      <app-messages-overview></app-messages-overview>
    </div>

    <div class="w-3/5 pl-4">
      <mat-card aria-label="Tabs card" class="h-full p-8">
        <div class="h-full">
          <app-messages-chat></app-messages-chat>
        </div>

        <div class="h-16">
          <mat-form-field class="w-full">
            <mat-label>{{ 'messages.write' | translate }}</mat-label>
            <input matInput [placeholder]="'messages.write' | translate" />
            <button mat-icon-button matSuffix class="mr-5 size-10 rounded-full bg-[var(--primary-40)] p-0">
              <mat-icon class="flex size-10 items-center justify-center text-[var(--primary-100)]">
                <span> near_me </span>
              </mat-icon>
            </button>
          </mat-form-field>
        </div>
      </mat-card>
    </div>
  </div>
</div>
